import View from './view.js';

class SortResultsView extends View {
  _parentElement = document.querySelector(`.sort-results`);

  addHandlerSortResults(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--sort`);
      if (!btn) return;
      const sortBy = btn.dataset.sort;
      handler(sortBy);
    });
  }

  showSortResults() {
    this._parentElement.classList.remove(`hidden`);
  }

  hideSortResults() {
    this._parentElement.classList.add(`hidden`);
  }
}

export default new SortResultsView();
